import { BASE_URL, BASE_URL_DEV } from "../_constants/urlConstants";
import { authHeader } from "../_utils/authHeader";
const { buildErrResponse } = require("../_utils/utils");
const { default: Axios } = require("axios");

export const UserService = {
  createUser,
  getAllusers,
  getUsersActive,
  getUsersBlocked,
  getUsersBySiteId,
  getUserById,
  updateUser,
  verifiedUser,
  deleteUser,
};

function createUser(body) {
  return new Promise((resolve, reject) => {
    Axios.post(`${BASE_URL_DEV}/user`, body)
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getAllusers() {
  const headers = authHeader();
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/user`, { headers })
      .then((resp) => resolve(resp))
      .catch((err) => reject(buildErrResponse(err)));
  });
}

function getUsersActive() {
  const headers = authHeader();
  return new Promise((resolve, reject) => {
    console.log("headers", headers);
    Axios.get(`${BASE_URL_DEV}/user/active`, { headers })
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}
function getUsersBlocked() {
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/user/blocked`)
      .then((resp) => resolve(resp))
      .catch((err) => reject(buildErrResponse(err)));
  });
}

function getUsersBySiteId(siteId) {
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/user/bySite?siteId=${siteId}`)
      .then((resp) => resolve(resp))
      .catch((err) => reject(buildErrResponse(err)));
  });
}

function getUserById(userId) {
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/user/byId?userId=${userId}`)
      .then((resp) => resolve(resp))
      .catch((err) => reject(buildErrResponse(err)));
  });
}

function updateUser(body) {
  return new Promise((resolve, reject) => {
    Axios.put(`${BASE_URL_DEV}/user/`, body)
      .then((resp) => resolve(resp))
      .catch((err) => reject(buildErrResponse(err)));
  });
}

function verifiedUser(body) {
  return new Promise((resolve, reject) => {
    console.log("verified user", body);
    Axios.put(`${BASE_URL_DEV}/user/verified`, body)
      .then((resp) => resolve(resp))
      .catch((err) => reject(buildErrResponse(err)));
  });
}

function deleteUser(userArrayId) {
  return new Promise((resolve, reject) => {
    Axios.patch(`${BASE_URL_DEV}/user/`, userArrayId)
      .then((resp) => resolve(resp))
      .catch((err) => reject(buildErrResponse(err)));
  });
}
